import { GenericCardProps } from './GenericCard.interface';
import {
  Card,
  CardContentContainer,
  CardMediaContainer,
} from './GenericCard.styled';

export const GenericCard = (props: GenericCardProps) => {
  return (
    <>
      <Card
        onClick={props.onClick}
        $isSelected={props.isSelected}
        data-testid="card">
        <CardMediaContainer>{props.cardMedia}</CardMediaContainer>
        <CardContentContainer>{props.additionalContent}</CardContentContainer>
      </Card>
      {props.cardMenuItems}
    </>
  );
};
